import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'e5168407-8d6f-4d9d-95e1-7e6fa5a6382c',
    countryCodes: ['PL'],
    locale: 'pl-PL',
});
